import { StyleSheet, Text, View } from "@react-pdf/renderer";

type PdfCardProps = {
  /** Couleur de fond du header */
  headerBackgroundColor: string;
  /** Icône (composant react-pdf) à afficher dans le header, ex: <PdfFolderAcceptedIcon size={20} /> */
  icon: React.ReactNode;

  title: string;
  subTitle: string;

  /** Couleur du texte du body (dépend du type de carte) */
  textColor: string;

  /** Compteur */
  counter: string;

  /** Ligne 1 à droite du compteur */
  line1: string;
  /** Ligne 2 à droite du compteur */
  line2: string;
};

const CARD_WIDTH = 165;
const CARD_HEIGHT = 84;
const HEADER_HEIGHT = 30;

const styles = StyleSheet.create({
  card: {
    width: CARD_WIDTH,
    height: CARD_HEIGHT,
    borderWidth: 1,
    borderRadius: 12,
    overflow: "hidden",
    backgroundColor: "#FFFFFF",
    flexDirection: "column",
  },

  header: {
    height: HEADER_HEIGHT,
    flexDirection: "row",
    alignItems: "center",
  },

  iconWrapper: {
    marginLeft: 12,
    marginRight: 12,
    marginTop: 6,
    marginBottom: 6,
    width: 16,
    height: 16,
    justifyContent: "center",
    alignItems: "center",
  },

  headerTextWrapper: {
    flexDirection: "column",
    justifyContent: "center",
    flexGrow: 1,
    paddingRight: 12,
  },

  headerTitle: {
    fontSize: 8,
    fontWeight: "bold",
    color: "white",
  },
  headerSubTitle: {
    marginTop: 1,
    fontSize: 8,
    color: "white",
  },

  body: {
    flexGrow: 1,
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 10,
  },

  counter: {
    width: 45,
    fontSize: 18,
    fontWeight: "bold",
    textAlign: "center",
  },

  bodyTextWrapper: {
    flexGrow: 1,
    flexDirection: "column",
    justifyContent: "center",
  },

  bodyLine1: {
    fontSize: 10,
    textTransform: "lowercase",
  },

  bodyLine2: {
    marginTop: 2,
    fontSize: 10,
    fontWeight: "bold",
    textTransform: "uppercase",
  },
});

/**
 * Composant de carte pour react-pdf-renderer.
 *
 * Affiche une carte avec :
 * - une bordure arrondie (radius 12)
 * - un header avec background, icône à gauche, puis titre + sous-titre
 * - un body avec compteur à gauche et 2 lignes de texte à droite
 */
export const PdfCard = ({
  headerBackgroundColor,
  icon,
  title,
  subTitle,
  textColor,
  counter,
  line1,
  line2,
}: PdfCardProps) => {
  return (
    <View style={[{ borderColor: headerBackgroundColor }, styles.card]}>
      <View style={[styles.header, { backgroundColor: headerBackgroundColor }]}>
        <View style={styles.iconWrapper}>{icon}</View>

        <View style={styles.headerTextWrapper}>
          <Text style={styles.headerTitle}>{title}</Text>
          <Text style={styles.headerSubTitle}>{subTitle}</Text>
        </View>
      </View>

      <View style={styles.body}>
        <Text style={[{ color: textColor }, styles.counter]}>{counter}</Text>

        <View style={styles.bodyTextWrapper}>
          <Text style={[{ color: textColor }, styles.bodyLine1]}>{line1}</Text>
          <Text style={[{ color: textColor }, styles.bodyLine2]}>{line2}</Text>
        </View>
      </View>
    </View>
  );
};
